const SET_COMPANY_SEGMENT = "set-company";

export const ROUTES = {
  root: "/",
  login: "/login",
  onboarding: "/onboarding",
  resetPasswordRequest: "/reset-password",
  resetPassword: (token: string) => `/reset-password/${token}`,

  partnerSignup: "/partner/signup",
  partnerSetUser: "/partner/set-user",
  partnerSetCompany: `/partner/${SET_COMPANY_SEGMENT}`,

  partner: "/partner",
  partnerAccount: "/partner/account",
  partnerQuoteRequests: "/partner/quote-requests",
  partnerQuoteRequest: (quoteRequestId: string) => `/partner/quote-requests/${quoteRequestId}`,
  partnerQuoteRequestsNew: "/partner/quote-requests/new",
  partnerSupport: "/partner/support",
  partnerSearch: "/partner/search",
  partnerDashboard: "/partner/dashboard",
  partnerManufacturingRanges: "/partner/manufacturing-ranges",

  partnerSettings: "/partner/settings",
  partnerSettingsInformations: "/partner/settings/informations",
  partnerSettingsAccount: "/partner/settings/account",
  partnerSettingsIncomingRequests: "/partner/settings/incoming-requests",
  partnerSettingsQuoting: "/partner/settings/quoting",
  partnerSettingsQuoteTemplates: "/partner/settings/quote-templates",
  partnerSettingsMachines: "/partner/settings/machines",
  partnerSettingsClients: "/partner/settings/clients",
  partnerSettingsClient: (id: string) => `/partner/settings/clients/${id}`,

  partnerIa: "/partner/ia",
  partnerIaSearch: "/partner/ia/search",
  partnerIaPrediction: "/partner/ia/prediction",
  partnerIaPredictionQuoteRequest: (quoteRequestId: string) =>
    `/partner/ia/prediction/quote-requests/${quoteRequestId}`,
  partnerIaSimilarPart: (partId: string) => `/partner/ia/similar-part/${partId}`,
  partnerIaDataset: "/partner/ia/dataset",

  partnerQuoteRequestLineCluster: (quoteRequestLineId: string) =>
    `/partner/quote-request-lines/${quoteRequestLineId}/cluster`,
  partnerQuoteRequestLineCompareCluster: (quoteRequestLineId: string) =>
    `/partner/quote-request-lines/${quoteRequestLineId}/compare-cluster`,

  v2: "/v2",
  v2QuoteRequests: "/v2/quote-requests",
  v2QuoteRequest: (quoteRequestId: string) => `/v2/quote-requests/${quoteRequestId}`,
  v2Search: "/v2/search",
  v2Settings: "/v2/settings",
  v2Support: "/v2/support",
  v2Onboarding: "/v2/onboarding",
  v2OnboardingActivityType: "/v2/onboarding/activity-type",
  v2OnboardingMaterialMode: "/v2/onboarding/material-mode",
  v2OnboardingMaterialSpecification: "/v2/onboarding/material-specification",
  v2OnboardingRawMaterialSpecification: "/v2/onboarding/raw-material-specification",
  v2OnboardingProcessStepConfiguration: "/v2/onboarding/process-step-configuration",
  v2OnboardingDefaultProcessSteps: "/v2/onboarding/default-process-steps",
  v2OnboardingFinish: "/v2/onboarding/finish",
} as const;
